export const MESSAGE = {
  ENTER_EDIT_MODE: 'em_edit_mode',
  ENTER_BROWSER_MODE: 'em_browser_mode',
  HIDE_EM_HEADER: 'hide_em_header',
  EXIT_EVENT_MARKER: 'exit_event_marker',
  RESET_EVENT_MARKER: 'reset_event_marker',
  TOGGLE_MOBILE_EVENT_MARKER: 'toggle_mobile_event_marker',
  EXIT_MOBILE_EVENT_MARKER: 'exit_mobile_event_marker',
  CLOSE_EDITOR: 'close_editor'
};



/** WEBPACK FOOTER **
 ** ./src/constants/message.js
 **/